import { Check } from "lucide-react";

const ITEMS = [
  "Gestão de chamados",
  "Manutenção",
  "Vistorias",
  "Desocupação",
  "Orçamentos",
  "Prestadores qualificados",
  "Acompanhamento",
  "Transparência",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-white/70">
          {item}
        </span>
        <Check className="h-3.5 w-3.5 shrink-0 text-brand-400" strokeWidth={3} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="overflow-hidden border-y border-white/10 bg-petrol py-5"
    data-testid="editorial-marquee"
    aria-hidden="true"
  >
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
